import { createCalendarPickerOptions, createTeamsChannelsOptions } from '../actions/privateActions';
import { initializeCalendarChannelPicker } from '../actions/publicActions';
import { getStore } from '../store/store';
import { getOptionsForPrimaryAccount, resetFilteredOptions } from 'owa-calendar-composite-picker';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { orchestrator } from 'satcheljs';

orchestrator(initializeCalendarChannelPicker, actionMessage => {
    createCalendarPickerOptions(actionMessage.event);

    const primaryAccountOptions = getOptionsForPrimaryAccount(getStore());

    if (
        primaryAccountOptions &&
        (isFeatureEnabled('cal-mf-calendarPickerTeams') ||
            isHostAppFeatureEnabled('teamsChannelOptions'))
    ) {
        createTeamsChannelsOptions(primaryAccountOptions.account);
    }

    resetFilteredOptions(getStore());
});
